import { render } from "./PageTwo.vue?vue&type=template&id=3134ccab&scoped=true"
import script from "./PageTwo.vue?vue&type=script&lang=js"
export * from "./PageTwo.vue?vue&type=script&lang=js"

import "./PageTwo.vue?vue&type=style&index=0&id=3134ccab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3134ccab"]])

export default __exports__